import React from 'react'
import PageHero from '../components/PageHero'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

export default function Programs() {
  return (
    <>
      <Navbar />
      <PageHero
        title="Our Programs"
        subtitle="Structured initiatives that integrate football, education, and life skills to support holistic child development."
        variant="programs"
        fadeClass="fade-in"
      />

      <main>
        {/* Intro */}
        <section className="section fade-in" style={{ textAlign: 'center' }}>
          <div className="container">
            <p className="statement-text" style={{ maxWidth: '820px', margin: '0 auto' }}>
              Each SISDI program is intentionally designed to create
              <span> lasting impact</span> on the pitch, in the classroom,
              and throughout life. Discover the programs we&apos;ve delivered, and those shaping lives today.
            </p>
          </div>
        </section>

        {/* Program Accordion */}
        <section className="section bg-light fade-in">
          <div className="container">
            <div className="program-stack">

              <div className="program-item">
                <button className="program-header">
                  <div className="program-header-left">
                    <i className="bi bi-lightbulb-fill"></i>
                    <h3>Football Training Sessions in Schools</h3>
                  </div>
                  <span className="program-toggle-icon"><i className="bi bi-plus-lg"></i></span>
                </button>
                <div className="program-content">
                  <div className="program-content-inner">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', alignItems: 'center' }}>
                      <img src="/images/program-football.jpeg" className="img-fluid rounded shadow-lg" alt="School football program" style={{ borderRadius: 'var(--radius-lg)' }} />
                      <div>
                        <p>We designed this program to change how young players are introduced to football.
                        We deliver structured football training sessions, open to boys and girls, that
                        combine theoretical classroom learning with practical on-field training.</p>
                        <p style={{ marginTop: '1rem' }}>In the classroom, children are introduced to football concepts in simple, relatable ways,
                        helping them build a mental understanding of the game before stepping onto the pitch.</p>
                        <p style={{ marginTop: '1rem' }}>These sessions also create a safe space for questions, discussion, and learning; such that when
                        they finally step onto the pitch, they are no longer guessing — they are applying
                        what they already understand through guided practical sessions.</p>
                        <p style={{ marginTop: '1rem' }}>This approach ensures that every child, regardless of skill level, has the opportunity to
                        participate, learn, and grow before any form of talent identification takes place.</p>
                        <p style={{ marginTop: '1rem' }}>Our belief is simple: <strong>everyone deserves a chance to experience, learn, and enjoy the beautiful game,</strong> before being evaluated.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="program-item">
                <button className="program-header">
                  <div className="program-header-left">
                    <i className="bi bi-book-half"></i>
                    <h3>Read, Learn, Play</h3>
                  </div>
                  <span className="program-toggle-icon"><i className="bi bi-plus-lg"></i></span>
                </button>
                <div className="program-content">
                  <div className="program-content-inner">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', alignItems: 'center' }}>
                      <img src="/images/program-life-skills.jpeg" className="img-fluid rounded shadow-lg" alt="Life skills program" style={{ borderRadius: 'var(--radius-lg)' }} />
                      <div>
                        <p>For many children, reading can feel like a chore — until it connects
                        with something they love. Through this program, we brought books to
                        life by placing football at the center of the story.</p>
                        <p style={{ marginTop: '1rem' }}>It is designed to strengthen literacy skills while reinforcing the
                        importance of education in a young player&apos;s development journey. By connecting their love
                        for football with reading, this helps children develop
                        a deeper interest in books, improve comprehension, and build confidence in learning.</p>
                        <p style={{ marginTop: '1rem' }}>The initiative sends a clear message: <strong>education and football go hand in hand</strong>, and
                        success on the pitch is strongest when supported by learning off it.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="program-item">
                <button className="program-header">
                  <div className="program-header-left">
                    <i className="bi bi-people-fill"></i>
                    <h3>Intra-School Football Competitions</h3>
                  </div>
                  <span className="program-toggle-icon"><i className="bi bi-plus-lg"></i></span>
                </button>
                <div className="program-content">
                  <div className="program-content-inner">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', alignItems: 'center' }}>
                      <img src="/images/program-community.jpeg" className="img-fluid rounded shadow-lg" alt="Community program" style={{ borderRadius: 'var(--radius-lg)' }} />
                      <div>
                        <p>The program provides young players with their first real experience
                        of football in a competitive setting within their schools. It is an opportunity for them
                        to test their skills, understand teamwork, and experience the discipline
                        required in organized football competition.</p>
                        <p style={{ marginTop: '1rem' }}>Through these matches, players also learn how to manage emotions,
                        respond to challenges, and apply lessons learned during training
                        in real-game situations.</p>
                        <p style={{ marginTop: '1rem' }}>Beyond the games, the program serves a deeper purpose —
                        an opportunity to work closely with the schools to observe
                        and <strong>identify promising talents for proper follow-up and guidance.</strong>
                        This collaborative approach ensures that talent development is not
                        rushed or isolated, but nurtured responsibly alongside education.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Programs CTA */}
        <section className="final-cta-section fade-in">
          <div className="container text-center">
            <h2 className="cta-text">
              Support Programs That <span>Make a Difference</span>
            </h2>
            <div style={{ marginTop: '2rem' }}>
              <a href="/get-involved" className="btn btn-accent btn-lg">
                <i className="bi bi-heart-fill"></i> Get Involved
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}
